import { SvgProps } from "../../types";

export default function TimesIcon({ className, stroke }: SvgProps) {
    return (
        <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M15.5564 4.94531L4.44531 16.0564"
                stroke={stroke || "#0B132B"}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.44531 4.94531L15.5564 16.0564"
                stroke={stroke || "#0B132B"}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
